import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["descriptionInput", "priorityList", "toggleButton"]

  connect() {
    const usingList = this.toggleButtonTarget.dataset.usingList === "true";
    this.showingPriorityList = usingList;

    this.descriptionInputTarget.classList.toggle("hidden", this.showingPriorityList);
    this.priorityListTarget.classList.toggle("hidden", !this.showingPriorityList);

    this.toggleButtonTarget.innerHTML = this.showingPriorityList
      ? ""
      : '<strong>Not sure?</strong> Choose from our priority list instead. <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="inline lucide lucide-move-right-icon lucide-move-right"><path d="M18 8L22 12L18 16"/><path d="M2 12H22"/></svg>';
  
    if (!this.showingPriorityList) {
      this.toggleButtonTarget.classList.remove("hidden")
    }
  }

  toggle() {
    this.showingPriorityList = !this.showingPriorityList;

    this.descriptionInputTarget.classList.toggle("hidden", this.showingPriorityList);
    this.priorityListTarget.classList.toggle("hidden", !this.showingPriorityList);

    this.toggleButtonTarget.innerHTML = this.showingPriorityList
      ? ""
      : '<strong>Not sure?</strong> Choose from our priority list instead. <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="inline lucide lucide-move-right-icon lucide-move-right"><path d="M18 8L22 12L18 16"/><path d="M2 12H22"/></svg>';

    if (this.showingPriorityList) {
      this.toggleButtonTarget.classList.add("hidden")
    }
  }
}
